import React from "react";
import { Container, Form, FormLabel, Tooltip, OverlayTrigger } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import { CalendarSelectorDA } from "./Componants/CalendarSelectorDA";
import "./DepositAudit.scss";
import { HotelSelector } from "./Componants/HotelSelector";
import { InfoTooltip } from "../../Common/Components/InfoTooltip";
import { resolve, reject } from "q";
import { toast } from "react-toastify";
import { Utils } from "../../Common/Utilis";
import { depositAudit } from "../../Common/Services/depositAudit";
import moment from "moment";
import { ReconcileDeposits } from "../Accounting/Reconcile/ReconcileDeposits";
import Popover from 'react-bootstrap/Popover';
import { debug } from "console";
import { ReactPageLoader } from "../../Common/Components/ReactPageLoader";
import { accountService } from "../../Common/Services/account";
export class DepositAudit extends React.Component<any, any> {
    private childHID: any;
    constructor(props: any) {
        super(props);
        this.childHID = React.createRef();
        this.state = {
            startDate: "",
            hidValue: 0,
            calendarDate: null,
            tableClass: "accountsTable accounts-tableWide layout-auto",
            IsGroupDeposit: true,
            ehidColumnArr: [],
            depositDataArr: [],
            isReconcileDeposit: false,
            istableloader: false,
        }
    }

    componentDidMount(): void {
        this.getDepositPagePermission();
    }

    getDepositPagePermission = () => {
        let IsPagePermission: boolean = false;
        accountService.DepositAuditPermission().then(async (result: any | null) => {
            if (result.length > 0) {
                IsPagePermission = (result[0].isBIDepositAudit == "Yes" ? true : false);
            }

            if (!IsPagePermission) {
                window.location.href = "/unauthorize-access";
            }
        });
    };


    handleCalendarDate = (date) => {
        if (this.state?.calendarDate !== date) {
            this.setState({ calendarDate: date, depositDataArr: [], ehidColumnArr: [] }, () => this.GetDepositData());
        }
    }

    selectHotelDropDown = (hotelDetails: any) => {
        if (hotelDetails.hotelID !== this.state.hidValue) {
            this.setState({ hotelName: hotelDetails.lettercode, hidValue: hotelDetails.hotelID, depositDataArr: [], ehidColumnArr: [] }, () =>
                this.GetDepositData()
            );
        }
    };

    IsGroupDeposit = (e) => {
        this.setState({ IsGroupDeposit: e.target.checked, depositDataArr: [], ehidColumnArr: [] }, () => {
            this.GetDepositData()
        })
    }

    GetDepositData = () => {
        this.getDepositPagePermission();
        this.setState({ istableloader: true });

        let request = {
            backHid: this.state.hidValue,
            date: this.state.calendarDate,
            Isgrouping: this.state.IsGroupDeposit ? 1 : 0,
        };

        if (this.state.hidValue !== 0 && this.state.calendarDate !== null) {
            depositAudit.GetDepositsAudit(request)
                .then(async (result) => {
                    if (!result || result.length === 0) {
                        return;
                    }
                    type AuditInfo = { name: string; type: string };
                    let auditInfo: AuditInfo[] = [];

                    result.forEach(item => {
                        item.Details.forEach(detail => {
                            auditInfo.push({ name: detail.AuditIdDisplayName, type: detail.Type });
                        });
                    });


                    const uniqueAuditNames = Array.from(
                        new Map(auditInfo.map(info => [info.name, info])).values()
                    ).sort((a, b) => (a.type === 'Ledger' ? 1 : b.type === 'Ledger' ? -1 : 0))
                        .map(info => info.name);

                    const groupedData = result.reduce((acc, item) => {
                        const date = item.Date;

                        item.Details.forEach((detail) => {
                            const auditName = detail.AuditIdDisplayName;
                            const amount = detail.TotalNetAmount || 0;

                            if (!acc[date]) {
                                acc[date] = {
                                    Date: moment(date).format("MM/DD/YYYY"),
                                    TotalNetAmount: 0,
                                    IsReconciled: detail.IsReconciled,
                                };
                            }

                            if (!acc[date][auditName]) {
                                acc[date][auditName] = {
                                    amount: 0,
                                    colorClass: 'badge color-gray',
                                    AccountName: detail.AccountName,
                                    AcctType: detail.AcctType,
                                    IsReconciled: detail.IsReconciled,
                                    Oprid: detail.Oprid,
                                    TotalAdjustment: detail.TotalAdjustment,
                                    TotalDiscount: detail.TotalDiscount,
                                    adjCOA: detail.adjCOA,
                                    adjNotes: detail.adjNotes,
                                    commCOA: detail.commCOA,
                                    commNotes: detail.commNotes,
                                    DATotalAdjustment: detail.DATotalAdjustment,
                                    DATotalDiscount: detail.DATotalDiscount,
                                    DAadjCOA: detail.DAadjCOA,
                                    DAadjNotes: detail.DAadjNotes,
                                    DAcommCOA: detail.DAcommCOA,
                                    DAcommNotes: detail.DAcommNotes,
                                    Type: detail.Type,
                                    AuditName: detail.AuditName,
                                    IsAccess: detail.IsAccess,
                                    isBlank: detail.isBlank
                                };
                            }

                            if (detail.IsReconciled === 'No' || detail.IsReconciled === false) {
                                acc[date][auditName].periodValue = moment(date).format("MM/YY");
                                let accdate = moment(date).format("MM/YY");
                                const result: string[] = accdate.split("/");
                                let MM = result[0].toString().length > 1 ? result[0] : "0" + result[0];
                                let Date = MM + "/01/" + result[1];
                                acc[date][auditName].accper = moment(Date).format("MM/DD/YY");
                            } else {
                                const result: string[] = detail.IsReconciled.split("/");
                                let MM = result[0].toString().length > 1 ? result[0] : "0" + result[0];
                                let Date = MM + "/01/" + result[1];
                                acc[date][auditName].periodValue = moment(Date).format("MM/YY");
                                acc[date][auditName].accper = moment(Date).format("MM/DD/YY");
                            }

                            acc[date][auditName].amount += amount;
                            acc[date].TotalNetAmount += amount;

                            if (amount !== 0) {
                                if (detail.IsReconciled === 'No' || detail.IsReconciled === false) {
                                    acc[date][auditName].colorClass = 'badge color-red';
                                } else {
                                    acc[date][auditName].colorClass = 'badge color-green';
                                }
                            }

                        });

                        return acc;
                    }, {});


                    const depositDataArr = Object.values(groupedData);


                    const dynamicColumns = [
                        {
                            text: 'Date',
                            dataField: 'Date',
                            align: 'left',
                            footerAlign: 'center',
                            // footer: () => ""  
                        },
                        ...uniqueAuditNames.map((auditName) => ({
                            text: auditName,
                            dataField: auditName,
                            headerAlign: 'right',
                            align: 'right',
                            footerAlign: 'right',
                            formatter: (cell, row) => {
                                const { amount, colorClass, TotalAdjustment, TotalDiscount, adjCOA, adjNotes, commCOA, commNotes
                                    , DATotalAdjustment, DATotalDiscount, DAadjCOA, DAadjNotes, DAcommCOA, DAcommNotes, Type, isBlank
                                } = row[auditName] || { amount: 0, colorClass: 'badge color-gray' };
                                const formattedAmount = amount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

                                return (<span className={isBlank == 1 ? '' : Type == "Ledger" ? 'badge color-gray' : `${colorClass}`}>

                                    <span className={this.IsShowData(row[auditName], 'popup') ? '' : "hide-icon"} >
                                        <OverlayTrigger
                                            placement="auto-start"
                                            delay={{ show: 250, hide: 400 }}
                                            overlay={
                                                <Popover id="popover-basic">
                                                    <Popover.Content>
                                                        <ul className="content-list">
                                                            {this.IsShowData(row[auditName], 'da') &&
                                                                <li>
                                                                    <div>Deposit Audit</div>
                                                                </li>
                                                            }

                                                            {this.IsShowData(row[auditName], 'daa') && (
                                                                <li>
                                                                    <div className="badge color-gray">Adj</div>
                                                                    <div className="amount-txt">${DATotalAdjustment}<span>{DAadjCOA}</span></div>
                                                                    <div className="notes">{DAadjNotes}</div>
                                                                </li>
                                                            )}
                                                            {this.IsShowData(row[auditName], 'dac') && (
                                                                <li>
                                                                    <div className="badge color-gray">Comm</div>
                                                                    <div className="amount-txt">${DATotalDiscount}<span>{DAcommCOA}</span></div>
                                                                    <div className="notes">{DAcommNotes}</div>
                                                                </li>
                                                            )}
                                                            {this.IsShowData(row[auditName], 're') &&
                                                                <li>
                                                                    <div>Reconcile</div>
                                                                </li>
                                                            }
                                                            {this.IsShowData(row[auditName], 'rea') && (
                                                                <li>
                                                                    <div className="badge color-gray">Adj</div>
                                                                    <div className="amount-txt">${TotalAdjustment}<span>{adjCOA}</span></div>
                                                                    <div className="notes">{adjNotes}</div>
                                                                </li>
                                                            )}
                                                            {this.IsShowData(row[auditName], 'rec') && (
                                                                <li>
                                                                    <div className="badge color-gray">Comm</div>
                                                                    <div className="amount-txt">${TotalDiscount}<span>{commCOA}</span></div>
                                                                    <div className="notes">{commNotes}</div>
                                                                </li>
                                                            )}
                                                        </ul>
                                                    </Popover.Content>
                                                </Popover>
                                            } >
                                            <span>
                                                <svg width="19" height="18" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M2.53613 12.75V14.25H7.03613V12.75H2.53613ZM2.53613 3.75V5.25H10.0361V3.75H2.53613ZM10.0361 15.75V14.25H16.0361V12.75H10.0361V11.25H8.53613V15.75H10.0361ZM5.53613 6.75V8.25H2.53613V9.75H5.53613V11.25H7.03613V6.75H5.53613ZM16.0361 9.75V8.25H8.53613V9.75H16.0361ZM11.5361 6.75H13.0361V5.25H16.0361V3.75H13.0361V2.25H11.5361V6.75Z" fill="#003E30" />
                                                </svg>
                                            </span>
                                        </OverlayTrigger>

                                    </span>

                                    <span className={Type == "Ledger" ? '' : "Pointer"} onClick={() => this.getreconcileBYPermission(row[auditName])}>{isBlank == 1 ? "" : formattedAmount}</span>

                                </span>)
                            },
                            // footer: (columnData) => columnData.reduce((acc, item) => acc + (item?.amount || 0), 0)
                            //     .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                        }))
                    ];

                    this.setState({
                        depositDataArr,
                        ehidColumnArr: dynamicColumns, istableloader: false
                    });
                    resolve();
                })
                .catch((error) => {
                    Utils.toastError(`Server Error: ${error}`, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                    reject();
                });
        }
    };



    IsShowData = (data, type) => {
        let isShow = false;
        switch (type) {
            case 'popup':
                if (((data.TotalAdjustment !== 0 || data.TotalDiscount !== 0 || data.DATotalAdjustment !== 0 || data.DATotalDiscount !== 0) &&
                    (data.TotalAdjustment !== undefined || data.TotalDiscount !== undefined || data.DATotalAdjustment !== undefined || data.DATotalDiscount !== undefined)))
                    isShow = true;
                break;
            case 'da':
                if (((data.DATotalAdjustment !== 0 || data.DATotalDiscount !== 0) && (data.DATotalAdjustment !== undefined || data.DATotalDiscount !== undefined)))
                    isShow = true;
                break;
            case 'daa':
                if (data.DATotalAdjustment !== 0 && data.DATotalAdjustment !== undefined)
                    isShow = true;
                break;
            case 'dac':
                if (data.DATotalDiscount !== undefined && data.DATotalDiscount !== 0)
                    isShow = true;
                break;

            case 're':
                if (((data.TotalAdjustment !== 0 || data.TotalDiscount !== 0) && (data.TotalAdjustment !== undefined || data.TotalDiscount !== undefined)))
                    isShow = true;
                break;
            case 'rea':
                if (data.TotalAdjustment !== 0 && data.TotalAdjustment !== undefined)
                    isShow = true;
                break;
            case 'rec':
                if (data.TotalDiscount !== 0 && data.TotalDiscount !== undefined)
                    isShow = true;
                break;

            default:
                isShow = false;
                break;
        }
        return isShow;

    }


    handleDepositModal = (event, rType) => {
        this.setState({ isReconcileDeposit: false }, () => {
            this.getDepositPagePermission();
            this.GetDepositData();
        });
    }

    getreconcileBYPermission = (rowData) => {
        let IsPagePermission: boolean = false;
        let IsReconcilePermission: boolean = false;
        IsReconcilePermission = (rowData.IsAccess == 1 ? true : false);
        accountService.DepositAuditPermission().then(async (result: any | null) => {
            if (result.length > 0) {
                IsPagePermission = (result[0].isBIDepositAudit == "Yes" ? true : false);
            }
            if (!IsPagePermission) {
                window.location.href = "/unauthorize-access";
            }
            if (IsReconcilePermission) {
                this.ShowReconcile(rowData)
            } else {

                Utils.toastError(`You don't have access to open the transaction.`, {
                    position: toast.POSITION.BOTTOM_RIGHT,
                    //  containerId: "DepositAudit"
                });

            }
        });
    };

    ShowReconcile = (rowData) => {
        if (rowData.Type !== "Ledger") {
            let Reconciled = "";
            if (rowData.IsReconciled === 'No' || rowData.IsReconciled === false) {
                Reconciled = "Unreconciled";
            } else {
                Reconciled = "Reconciled";
            }

            this.setState({
                acctStatus: Reconciled,
                AccountName: rowData.AccountName,
                periodValue: rowData.periodValue,
                hidValue: this.state.hidValue,
                hotelName: this.state.hotelName,
                accper: rowData.accper,
                OprID: rowData.Oprid,
                AccountType: rowData.AuditName,
                pageType: rowData.AuditName,
                acctType: rowData.AcctType,
                isGroup: false
            }, () => {
                this.setState({ isReconcileDeposit: true })
            })
        }
    }

    render() {
        const columns = [
            ...this.state.ehidColumnArr,
        ];
        return (
            <>
                {this.state.isReconcileDeposit && (
                    <ReconcileDeposits
                        acctStatus={this.state.acctStatus}
                        headerControlsDisabled={true}
                        accountName={this.state.AccountName}
                        periodValue={this.state.periodValue}
                        hidValue={this.state.hidValue}
                        hotelName={this.state.hotelName}
                        accper={this.state.accper}
                        OprID={this.state.OprID}
                        AccountType={this.state.AccountType}
                        pageType={this.state.pageType}
                        acctType={this.state.acctType}
                        //handleNextbutton={this.handleNextButton}
                        handleReconcileDepositModal={this.handleDepositModal}
                        isGroup={this.state.isGroup}
                    >
                    </ReconcileDeposits>
                )}
                <div className="DepositAudit" >
                    <Container fluid className="body-sec">
                        <div className="page-heading underline d-flex">
                            <HotelSelector
                                onClickEvent={this.selectHotelDropDown}
                                ref={this.childHID}
                                featureIds="1"
                                hotelTypes="2"
                            />
                            <div className="mr-auto d-flex align-items-center">
                                Deposit Audit
                            </div>
                        </div>
                        {this.state.hidValue !== 0 &&
                            <div className="navigation-menus d-flex">
                                <CalendarSelectorDA
                                    id={"chartPeriodSelector"}
                                    defaultValue={this.state.calendarDate}
                                    allowAllBackDates={true}
                                    onChange={this.handleCalendarDate} >
                                </CalendarSelectorDA>
                                <div className="mr-auto"></div>
                                <div className='d-flex align-items-center'>
                                    <FormLabel className='mb-0'>Group Deposits</FormLabel>
                                    <Form.Check
                                        checked={this.state.IsGroupDeposit}
                                        onChange={this.IsGroupDeposit}
                                        type="switch"
                                        className="sm-controll toggleButtonRP"
                                        label=""
                                        id="daily-flash-switch"
                                    />
                                    <OverlayTrigger
                                        placement="bottom"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={
                                            <Tooltip id={"tooltip-displayName"}>
                                                If enabled, deposit type columns (e.g., Amex, Visa, Discover, etc…) will be grouped if the client has configured this in their system.
                                            </Tooltip>
                                        }>
                                        <span>
                                            <InfoTooltip />{" "}
                                        </span>
                                    </OverlayTrigger>
                                </div>
                            </div>
                        }

                        <div className={this.state.tableClass}>
                            {this.state.depositDataArr.length > 0 && !this.state.istableloader &&
                                <BootstrapTable
                                    id="tblDA"
                                    keyField="rno"
                                    data={this.state.depositDataArr}
                                    columns={columns}
                                    noDataIndication={"No record found."}
                                />
                            }

                        </div>
                        {this.state.istableloader && (
                            <ReactPageLoader useas={"reconcile"} />
                        )}
                    </Container>
                </div>
            </>
        )

    }

}


